<template>
  <section class="d-flex flex-column h-full">
    <TopAppBar
        v-if="url_list_type == true"
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        ref="top_app_bar"
        staticMode="true"
    ></TopAppBar>
    <TopAppBar
        v-if="url_list_type == false"
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        staticMode="true"
    >
    </TopAppBar>
    <div class="flex-grow-1 scroll-y">
      <component :is="isListType"></component>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <div class="fixed-bottom-icon bg-mainBtn shadow1 pdr-18 pdl-18 pdt-17 pdb-17"
         v-if="isShowVocButton"
         @click="goToWrite()" >
      <i class="material-icons t-color-white">add</i>
      <span class="d-inline-block pdl-8 t-color-white t-nowrap t-body2">{{$t('S10051')}}</span>
    </div>
  </section>
</template>

<script>
/**
 * 단독설문 메인 컴포넌트(independent survey main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";

export default {
  name: "survey",
  components: {
    total: () => import("@/components/independentSurvey/list/Total.vue"),
    my: () => import("@/components/independentSurvey/list/My.vue"),
    result: () => import("@/components/independentSurvey/list/Result.vue"),
    category: () => import("@/components/independentSurvey/list/Category.vue"),
    TopAppBar,
  },

  data() {
    return {
      listType: "total",
      url_list_type: false,
    };
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {
      let routerLen = this.$route.matched.length;
      if (this.$route.query && this.$route.query.listType === "category") {
        let learnBack = localStorage.getItem("mysurvey");
        if (learnBack == "myinformation") {
          localStorage.removeItem("mysurvey");
          this.setTopAppBarBackToMyInformation(this.$t("212"));
        } else {
          if (routerLen == 1) {
            this.url_list_type = true;
            this.leftBtnMode = "arrow_back";
            this.rightBtnMode = "search";
            this.title = this.$t("212");
            this.leftBtnMethod = () => {
              this.$router.push({
                name: "IndependentSurvey",
              });
            };
            this.rightBtnMethod = "";
          } else {
            this.url_list_type = true;
            this.leftBtnMode = "arrow_back";
            this.rightBtnMode = "search";
            this.title = this.$t("212");
            this.leftBtnMethod = () => {
              this.$router.go(-1);
            };
            this.rightBtnMethod = "";
          }
        }
      } else {
        this.url_list_type = false;
        this.setTopAppBarHomeBlank(this.$t("212"));
      }
    },
  },
  computed: {
    isListType() {
      return this.$route.query.listType || "total";
    },
    isShowVocButton() {
      const listType = ["total", "my"];
      return false;
      // return this.$route.query.listType === undefined || listType.indexOf(this.$route.query.listType) > -1;
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.listType === "category") {
      let learnBack = localStorage.getItem("mysurvey");
      if (learnBack == "myinformation") {
        localStorage.removeItem("mysurvey");
        this.setTopAppBarBackToMyInformation(this.$t("212"));
      } else {
        this.url_list_type = true;
        // this.setTopAppBarBackSearch(this.$t("212"));
        this.leftBtnMode = "arrow_back";
        this.rightBtnMode = "search";
        this.title = this.$t("212");
        this.leftBtnMethod = () => {
          this.$router.go(-1);
        };
        this.rightBtnMethod = "";
      }
    } else {
      console.log("this.$route.query else ", this.$route.params.distId);
      this.url_list_type = false;
      this.setTopAppBarHomeBlank(this.$t("212"));
    }

    // set header title

    const ripples = [].map.call(
        document.querySelectorAll(".ripple-item"),
        function (el) {
          let ripple = new MDCRipple.attachTo(el);
          return ripple;
        }
    );
  },

  methods: {
    changeMode(mode) {
      this.listType = mode;
    },

    //VOC Write
    goToWrite(){
      this.$router.push({
        name: 'Voc',
      });
    },
  },
};
</script>